// extracted by mini-css-extract-plugin
module.exports = {"select":"RequestsList_select__3PBGA"};